import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnboardingMarketMatch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 185,
	height: 185,
	viewBox: "0 0 185 185",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 92.5,
			cy: 92.5,
			r: 91.75,
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 92.498,
			cy: 92.498,
			r: 59.5761,
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 92.4969,
			cy: 92.4989,
			r: 43.4891,
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 92.4959,
			cy: 92.4998,
			r: 27.4022,
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 92.499,
			cy: 92.499,
			r: 75.663,
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 92.5027,
			cy: 92.4969,
			r: 11.3152,
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.8906 93.02C89.4873 92.4454 89.5053 91.4958 88.9307 90.899C88.356 90.3023 87.4065 90.2843 86.8097 90.8589L87.8501 91.9395L88.8906 93.02ZM55.2801 120.289L56.4403 121.239V121.239L55.2801 120.289ZM55.2801 167.196L55.867 165.815L55.2801 167.196ZM87.8501 91.9395L86.8097 90.8589C83.1036 94.4275 76.6788 99.4557 70.243 104.682C63.8917 109.839 57.5003 115.213 54.1198 119.338L55.2801 120.289L56.4403 121.239C59.5889 117.397 65.7159 112.222 72.1341 107.011C78.4677 101.868 85.0635 96.705 88.8906 93.02L87.8501 91.9395ZM55.2801 120.289L54.1198 119.338C49.1118 125.45 43.9199 135.279 42.5683 144.774C41.8904 149.536 42.1644 154.32 44.0198 158.524C45.892 162.766 49.3197 166.291 54.6931 168.576L55.2801 167.196L55.867 165.815C51.1464 163.808 48.3083 160.811 46.7644 157.313C45.2038 153.777 44.9115 149.6 45.5384 145.197C46.7964 136.359 51.6986 127.026 56.4403 121.239L55.2801 120.289ZM55.2801 167.196L54.6931 168.576C71.2509 175.617 86.5561 176.014 92.503 176.014V174.514V173.014C86.7069 173.014 71.8761 172.623 55.867 165.815L55.2801 167.196Z",
			fill: "#B3EC49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.1094 93.02C95.5127 92.4454 95.4947 91.4958 96.0693 90.899C96.644 90.3023 97.5935 90.2843 98.1903 90.8589L97.1499 91.9395L96.1094 93.02ZM129.72 120.289L128.56 121.239V121.239L129.72 120.289ZM129.72 167.196L129.133 165.815L129.72 167.196ZM97.1499 91.9395L98.1903 90.8589C101.896 94.4275 108.321 99.4557 114.757 104.682C121.108 109.839 127.5 115.213 130.88 119.338L129.72 120.289L128.56 121.239C125.411 117.397 119.284 112.222 112.866 107.011C106.532 101.868 99.9365 96.705 96.1094 93.02L97.1499 91.9395ZM129.72 120.289L130.88 119.338C135.888 125.45 141.08 135.279 142.432 144.774C143.11 149.536 142.836 154.32 140.98 158.524C139.108 162.766 135.68 166.291 130.307 168.576L129.72 167.196L129.133 165.815C133.854 163.808 136.692 160.811 138.236 157.313C139.796 153.777 140.088 149.6 139.462 145.197C138.204 136.359 133.301 127.026 128.56 121.239L129.72 120.289ZM129.72 167.196L130.307 168.576C113.749 175.617 98.4439 176.014 92.497 176.014V174.514V173.014C98.2931 173.014 113.124 172.623 129.133 165.815L129.72 167.196Z",
			fill: "#B3EC49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.7854 93.1122C89.4331 92.5956 89.5394 91.6519 89.0229 91.0042C88.5063 90.3565 87.5625 90.2502 86.9149 90.7667L87.8501 91.9395L88.7854 93.1122ZM55.2801 115.42L56.3464 116.475V116.475L55.2801 115.42ZM55.2801 154.272L55.7784 152.857V152.857L55.2801 154.272ZM87.8501 91.9395L86.9149 90.7667C83.2113 93.7204 76.7888 97.8836 70.3514 102.213C64.0051 106.482 57.6054 110.937 54.2137 114.365L55.2801 115.42L56.3464 116.475C59.4838 113.304 65.6025 109.023 72.0257 104.703C78.3577 100.444 84.9557 96.1664 88.7854 93.1122L87.8501 91.9395ZM55.2801 115.42L54.2137 114.365C49.1945 119.439 43.9468 127.639 42.575 135.621C41.8845 139.639 42.1597 143.711 44.0683 147.293C45.9882 150.896 49.4582 153.812 54.7818 155.687L55.2801 154.272L55.7784 152.857C51.0079 151.177 48.2121 148.69 46.7159 145.882C45.2085 143.053 44.9174 139.704 45.5317 136.13C46.7695 128.927 51.616 121.257 56.3464 116.475L55.2801 115.42ZM55.2801 154.272L54.7818 155.687C71.3039 161.506 86.5722 161.833 92.503 161.833V160.333V158.833C86.6909 158.833 71.8231 158.508 55.7784 152.857L55.2801 154.272Z",
			fill: "#E08F8F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.2146 93.1122C95.5669 92.5956 95.4606 91.6519 95.9771 91.0042C96.4937 90.3565 97.4375 90.2502 98.0851 90.7667L97.1499 91.9395L96.2146 93.1122ZM129.72 115.42L128.654 116.475V116.475L129.72 115.42ZM129.72 154.272L129.222 152.857V152.857L129.72 154.272ZM97.1499 91.9395L98.0851 90.7667C101.789 93.7204 108.211 97.8836 114.649 102.213C120.995 106.482 127.395 110.937 130.786 114.365L129.72 115.42L128.654 116.475C125.516 113.304 119.397 109.023 112.974 104.703C106.642 100.444 100.044 96.1664 96.2146 93.1122L97.1499 91.9395ZM129.72 115.42L130.786 114.365C135.806 119.439 141.053 127.639 142.425 135.621C143.116 139.639 142.84 143.711 140.932 147.293C139.012 150.896 135.542 153.812 130.218 155.687L129.72 154.272L129.222 152.857C133.992 151.177 136.788 148.69 138.284 145.882C139.791 143.053 140.083 139.704 139.468 136.13C138.231 128.927 133.384 121.257 128.654 116.475L129.72 115.42ZM129.72 154.272L130.218 155.687C113.696 161.506 98.4278 161.833 92.497 161.833V160.333V158.833C98.3091 158.833 113.177 158.508 129.222 152.857L129.72 154.272Z",
			fill: "#E08F8F"
		})
	]
});
export default SvgOnboardingMarketMatch;
